import type { Meta, StoryObj } from "@storybook/react";
import noop from "lodash/noop";
import { ScrollView } from "react-native";

import { MedicalReviewState } from "@/constants/Onboarding";
import type { MedicalReviewCardProps } from "@/ui/components/onboarding/v2/cards/MedicalReviewCard";
import { MedicalReviewCard } from "@/ui/components/onboarding/v2/cards/MedicalReviewCard";
import { VStack } from "@/ui/layout";

const states: MedicalReviewState[] = [
  MedicalReviewState.Pending,
  MedicalReviewState.Approved,
  MedicalReviewState.NotApproved,
];

const StoryMeta: Meta<MedicalReviewCardProps> = {
  title: "Components/Onboarding/Cards/Medical Review Card",
  component: MedicalReviewCard,
  args: {
    onActionPress: noop,
    state: MedicalReviewState.Pending,
    testID: "story",
  },
  argTypes: {
    state: {
      control: "select",
      options: states,
    },
  },
};

type Story = StoryObj<MedicalReviewCardProps>;

const Pending: Story = {
  args: { state: MedicalReviewState.Pending },
};

const Approved: Story = {
  args: { state: MedicalReviewState.Approved },
};

const NotApproved: Story = {
  args: { state: MedicalReviewState.NotApproved },
};

const AllStates: Story = {
  render: (args) => (
    <ScrollView>
      <VStack gap={16} padding={16} width="100%">
        {states.map((state) => (
          <MedicalReviewCard
            {...args}
            key={state}
            state={state}
            testID={state}
          />
        ))}
      </VStack>
    </ScrollView>
  ),
};

const AllStatesProxy: Story = {
  args: { patientName: "Renee" },
  render: (args) => (
    <ScrollView>
      <VStack gap={16} padding={16} width="100%">
        {states.map((state) => (
          <MedicalReviewCard
            {...args}
            key={state}
            state={state}
            testID={state}
          />
        ))}
      </VStack>
    </ScrollView>
  ),
};

export { AllStates, AllStatesProxy, Approved, NotApproved, Pending };
export default StoryMeta;
